<template>
  <v-card class="pa-5 text-center">
    <v-container grid-list-xs>
      <h4 class="mb-3">
        ¿Estás buscando un practicante? ¡Ingresa una oferta de práctica!
      </h4>
      <v-btn
        elevation="0"
        color="primary"
        href="https://usmsaae.gpsrrhh.com/"
        target="_blank"
        rel="noopener"
        >INGRESAR A PORTAL</v-btn
      >
      <p class="mt-4 mb-0 text-caption">
        Dudas para publicar práctica contactar a
        <a href="mailto:apoyo.gestal@usm.cl">apoyo.gestal@usm.cl</a>
      </p>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "PortalPracticasCard",
};
</script>
